(function () {
  var STORAGE_KEY = 'as_dark_mode';
  var html = document.documentElement;

  // Apply saved preference immediately
  if (localStorage.getItem(STORAGE_KEY) === '1') {
    html.classList.add('dark-mode');
  }

  function isDark() {
    return html.classList.contains('dark-mode');
  }

  function updateBtn(btn) {
    btn.textContent = isDark() ? '☀️' : '🌙';
    btn.setAttribute('aria-label', isDark() ? 'Switch to light mode' : 'Switch to dark mode');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.createElement('button');
    btn.className = 'dark-mode-btn';
    updateBtn(btn);
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      html.classList.toggle('dark-mode');
      localStorage.setItem(STORAGE_KEY, isDark() ? '1' : '0');
      updateBtn(btn);
    });
  });
})();
